export const LOCAL_STORAGE_OAUTH_EVENT_NAME = 'oauth-storage';
export const LOCAL_STORAGE_OAUTH_TOKENS_KEY = 'wg-oauth-tokens';

export const ACCESS_TOKEN_EXPIRED_EVENT_NAME = 'access-token-expired';
export const ACCESS_TOKEN_UNEXPIRED_EVENT_NAME = 'access-token-unexpired';

export const ACCESS_TOKEN_REFRESHING = 'refreshing-access-token';
export const ACCESS_TOKEN_REFRESHING_DONE = 'refreshing-access-token-done';
